import { TOGGLE_OPENED_PROPERTY } from '../constants';

export const actionToggleOpenedProperty = openedPropertyIndex => {
  return async dispatch => {
    dispatch({ type: TOGGLE_OPENED_PROPERTY, openedPropertyIndex });
  };
};

export default actionToggleOpenedProperty;
